export { trendingTracks as tracks } from "./trackCatalog";

export const artists = [
  { name: "Burna Boy", meta: "Afro-fusion · 3 releases this month", img: "https://picsum.photos/seed/mu-artist-burnaboy/200/200" },
  { name: "Tems", meta: "R&B / Soul · 2 releases this month", img: "https://picsum.photos/seed/mu-artist-tems/200/200" },
  { name: "Asake", meta: "Afrobeats / Fuji · 4 releases this month", img: "https://picsum.photos/seed/mu-artist-asake/200/200" },
  { name: "Ayra Starr", meta: "Afropop · 1 release this month", img: "https://picsum.photos/seed/mu-artist-ayrastarr/200/200" }
];

export const services = [
  { title: "Music Distribution", desc: "Release your music on major streaming platforms and reach listeners worldwide." },
  { title: "Music Promotion", desc: "Get your songs in front of the right audience through targeted campaigns." },
  { title: "Playlist Pitching", desc: "Increase your chances of landing on curated playlists that matter." },
  { title: "Press & PR", desc: "Build credibility with professional media coverage and artist press kits." },
  { title: "Social Campaigns", desc: "Expand your reach with promotional strategies tailored for every platform." }
];

export const features = [
  { title: "Discover New Talent", desc: "Explore fresh music from rising and established artists." },
  { title: "Professional Promotion", desc: "Marketing solutions designed to increase visibility and audience engagement." },
  { title: "AI-Powered Artist Tools", desc: "Create professional Electronic Press Kits in minutes." },
  { title: "Music Distribution", desc: "Reach major streaming platforms with ease." },
  { title: "Entertainment Community", desc: "Stay connected through music, fashion, lifestyle and culture." },
  { title: "Secure Platform", desc: "A trusted space for artists, fans, brands, and partners." }
];

export const stories = [
  { text: "MusicUntamed helped us connect our latest release with new listeners faster than ever.", source: "Independent Artist" },
  { text: "The promotion campaign delivered great visibility and meaningful engagement.", source: "Label Partner" },
  { text: "Creating our artist profile was simple, professional, and exactly what we needed.", source: "Touring Artist" }
];

export const partners = ["APEX RECORDS", "VIBEZ FM", "STREETWEAR CO", "LAGOS SOUND", "CULTURE HAUS"];

export const tickerList = [
  { n: "01", t: "Calm Down", a: "Rema" },
  { n: "02", t: "Essence", a: "Wizkid ft. Tems" },
  { n: "03", t: "Last Last", a: "Burna Boy" },
  { n: "04", t: "Higher", a: "Tems" },
  { n: "05", t: "Unavailable", a: "Davido ft. Musa Keys" },
  { n: "06", t: "Rush", a: "Ayra Starr" },
  { n: "07", t: "Gadeem", a: "Rybenna" }
];

export const navLinks = [
  { label: "Home", href: "/" },
  { label: "Music", href: "/music" },
  { label: "Services", href: "/services" },
  { label: "Lifestyle", href: "/lifestyle" },
  { label: "Shop", href: "/shop" },
  { label: "Blog", href: "/blog" },
  { label: "About", href: "/about" },
  { label: "Contact", href: "/contact" }
];
